import { gql, useQuery } from '@apollo/client';
import { useEffect, useState } from 'react';

const getEventsQuery = fields => {
    return gql`
        query getEvents($codes: [String!]) {
            events(codes: $codes) {
                ${fields ||
                    `
                    id
                    beginsAt
                    code
                    endsAt
                    image
                    location {
                        country
                        address
                        address2
                        address3
                        city
                        stateProvince
                        zip
                    }
                    mapYourShowId
                    recordId
                    title
                    url
                    `}
            }
        }
    `;
};

const useEventFromGraph = ({ code, fields }) => {
    const [event, setEvent] = useState();
    const { data, ...rest } = useQuery(getEventsQuery(fields), {
        variables: {
            codes: [code],
        },
    });

    useEffect(() => {
        if (!data) {
            return;
        }

        setEvent(data.events.length > 0 ? data.events[0] : null);
    }, [data]);

    return { event, ...rest };
};

export default useEventFromGraph;
